var _defs, _path, _polygon, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1024",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1025"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1026",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M479.068,96h-216.32l-22.515,87.1l-8.083,57.242l43.329,120.845l6.957,146.639h196.633 c18.184,0,32.932-14.748,32.932-32.932V128.932C512,110.748,497.252,96,479.068,96z",
    className: "colore6e6e6 svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#52cc99",
    points: "368.696 416 282.435 507.826 251.882 416 264.348 382.521",
    className: "color3a5bbc svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M469.565,244.174v-20.87h-79.304v-29.217h-20.87v29.217H297.92v20.87h115.89 c-6.446,13.572-17.621,35.215-32.978,58.035c-14.132-17.649-23.062-29.931-23.168-30.077l-6.129-8.445l-16.892,12.255l6.127,8.445 c0.477,0.658,10.876,14.963,27.338,35.3c-11.222,13.749-31.808,36.106-42.655,46.952l14.756,14.756 c9.362-9.362,28.774-30.214,41.426-45.327c16.459,19.553,32.523,37.194,47.854,52.526l7.378,7.378l14.758-14.755l-7.378-7.378 c-15.839-15.839-32.519-34.264-49.647-54.799c22.133-31.823,36.48-61.956,42.2-74.866H469.565z",
    className: "colorgray svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#52cc99",
    d: "M349.329,357.523L368.696,416H251.882H32.932C14.734,416,0,401.252,0,383.068V37.106 C0,18.922,14.734,4.174,32.932,4.174h199.416L262.748,96l45.607,137.739L349.329,357.523z",
    className: "color518ef8 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M149.301,287.374c-42.77,0-77.565-34.795-77.565-77.565s34.795-77.565,77.565-77.565 c20.704,0,40.182,8.065,54.845,22.712l-14.749,14.766c-10.723-10.71-24.961-16.608-40.097-16.608 c-31.263,0-56.696,25.433-56.696,56.696s25.433,56.696,56.696,56.696c27.698,0,50.82-19.967,55.733-46.261h-55.731v-20.87h77.565 v10.435C226.866,252.579,192.071,287.374,149.301,287.374z",
    className: "colorfff svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTranslate);
export default __webpack_public_path__ + "static/media/google-translate.296e783845434101d7e50788f8b00334.svg";
export { ForwardRef as ReactComponent };